import { AppPricesProcessor } from 'common/repositoryProcessors/index';
import Util from 'common/services/util/-RFC.util';

const _directiveDependencies = [];
const _controllerDependencies = ['$scope', '$location', '$anchorScroll'];

class AppPriceController {

    constructor($scope, $location, $anchorScroll) {

        const appPricesProcessorObservable = AppPricesProcessor.getObservable();

        $scope.showYearLabel = $scope.showyearlabel;
        $scope.showMonthLabel = $scope.showmonthlabel;
        $scope.showUpsellYearlyPrice = $scope.showupsellyearlyprice;
        $scope.showTotalPrice = $scope.showtotalprice;
        $scope.subscriptionMonths = $scope.subscriptionmonths || 12;
        $scope.renewalPrices = CWCONFIG.cma.subscriptions.renewalPrices;
        $scope.showCmaLabel = $scope.showcmalabel;

        $scope.gotoAnchor = (anchor) => {

            $location.hash(anchor);
            $anchorScroll();

        };

        const onNextAppPricesProcessor = () => {

            $scope.appPrices = AppPricesProcessor.getAll();
            const currentPriceID = $scope.appid;
            $scope.currentPrice = $scope.appPrices.find(price => price.id === currentPriceID);

            if ($scope.currentPrice) {

                $scope.currentAnnual = $scope.appPrices.find(price => price.id === `${$scope.currentPrice.relationships.app.data.id}_12_1`);

            }

            $scope.currentPrice.attributes.upsellYearlyPrice =
                $scope.checkUpsellYearlyPrice(
                    $scope.currentPrice.attributes.price,
                    $scope.currentPrice.attributes.price_string,
                );

            if ($scope.currentPrice.attributes.promotion) {

                $scope.currentPrice.attributes.promotion.upsellYearlyPrice =
                $scope.checkUpsellYearlyPrice(
                    $scope.currentPrice.attributes.promotion.price,
                    $scope.currentPrice.attributes.promotion.total_price_string,
                );

            }

            if ($scope.currentPrice && Util.deepFind($scope.currentPrice, 'attributes.promotion')) {

                $scope.hasPromotion = true;

            } else {

                $scope.hasPromotion = false;

            }

        };

        $scope.$watch('appid', () => {

            onNextAppPricesProcessor();

        });

        $scope.checkUpsellYearlyPrice = (price, priceString) => {

            const monthlyPriceString = priceString;
            const yearlyPrice = price;

            // Calculate the new price (save it as a string)
            let newPrice =
            String(parseFloat(yearlyPrice / $scope.subscriptionMonths).toFixed(2));

            // Replace dot notation (if necessary)
            newPrice = (monthlyPriceString.indexOf(',') > -1) ? newPrice.split('.').join(',') : newPrice;

            // Check digit positions
            const regex = new RegExp('\\d', 'g');
            let digit;
            const positions = [];
            // eslint-disable-next-line no-cond-assign
            while (digit = regex.exec(monthlyPriceString)) {

                positions.push(digit.index);

            }

            // Save the new price in the price_string format
            const upsellYearlyPrice = (positions[0] === 0) ?
                newPrice.concat(monthlyPriceString.substring(positions[positions.length - 1] + 1)) :
                monthlyPriceString.substring(0, positions[0]).concat(newPrice);

            return upsellYearlyPrice;

        };

        this.appPricesRepositorySubscriber = appPricesProcessorObservable.subscribe(
            onNextAppPricesProcessor,
            () => { },
            () => { },
        );

    }

}


class AppPriceDirective {

    constructor() {

        this.template = require('./app-price.html');
        this.restrict = 'EA';
        this.replace = true;

        this.scope = {
            appid: '=',
            showyearlabel: '=',
            showmonthlabel: '=',
            showupsellyearlyprice: '=',
            subscriptionmonths: '=',
            showtotalprice: '=',
            showcmalabel: '=',
        };

        _controllerDependencies.push(($scope, $location, $anchorScroll) =>
            new AppPriceController($scope, $location, $anchorScroll));
        this.controller = _controllerDependencies;
        this.controllerAs = 'AppPriceCtrl';

    }

}

_directiveDependencies.push(() => new AppPriceDirective());


angular.module('directives')
    .directive('appPrice', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/app-price/app-price.js